import "react";
const zn = {
  MOBILE: 640,
  TABLET: 768
};
function Mn(e, t) {
  const n = new Date(e);
  return n.setDate(n.getDate() + t), n;
}
const Ye = (e, t) => e.split(";").map((n) => n.split("=")).filter(([n]) => !t || t.includes(n.trim())).reduce(
  (n, [r, o]) => (n[r.trim()] = o.trim(), n),
  {}
), x = ({ access_token: e, refresh_token: t } = {}) => {
  const n = {}, r = Ye(document.cookie, ["access_token", "refresh_token"]);
  return n.Authorization = `Bearer ${e ?? r.access_token}`, r.refresh_token && (n.refresh_token = t ?? r.refresh_token), n;
}, et = (e = {}) => {
  const t = {};
  return e.access_token && (t.Authorization = `Bearer ${e.access_token}`), t;
};
var tt = Object.defineProperty, nt = (e, t, n) => t in e ? tt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, W = (e, t, n) => nt(e, typeof t != "symbol" ? t + "" : t, n);
class me extends Error {
  constructor(t, n, r) {
    super(t), W(this, "code"), W(this, "errorData"), this.name = "HeError", this.code = n, this.errorData = r;
  }
}
function Ne(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: rt } = Object.prototype, { getPrototypeOf: fe } = Object, G = /* @__PURE__ */ ((e) => (t) => {
  const n = rt.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), C = (e) => (e = e.toLowerCase(), (t) => G(t) === e), X = (e) => (t) => typeof t === e, { isArray: k } = Array, q = X("undefined");
function ot(e) {
  return e !== null && !q(e) && e.constructor !== null && !q(e.constructor) && T(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const je = C("ArrayBuffer");
function st(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && je(e.buffer), t;
}
const it = X("string"), T = X("function"), Ue = X("number"), Z = (e) => e !== null && typeof e == "object", at = (e) => e === !0 || e === !1, $ = (e) => {
  if (G(e) !== "object")
    return !1;
  const t = fe(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, ct = C("Date"), ut = C("File"), lt = C("Blob"), ft = C("FileList"), dt = (e) => Z(e) && T(e.pipe), ht = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || T(e.append) && ((t = G(e)) === "formdata" || // detect form-data instance
  t === "object" && T(e.toString) && e.toString() === "[object FormData]"));
}, pt = C("URLSearchParams"), [mt, gt, yt, bt] = ["ReadableStream", "Request", "Response", "Headers"].map(C), wt = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function I(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, o;
  if (typeof e != "object" && (e = [e]), k(e))
    for (r = 0, o = e.length; r < o; r++)
      t.call(null, e[r], r, e);
  else {
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), s = i.length;
    let u;
    for (r = 0; r < s; r++)
      u = i[r], t.call(null, e[u], u, e);
  }
}
function Pe(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, o;
  for (; r-- > 0; )
    if (o = n[r], t === o.toLowerCase())
      return o;
  return null;
}
const U = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, _e = (e) => !q(e) && e !== U;
function se() {
  const { caseless: e } = _e(this) && this || {}, t = {}, n = (r, o) => {
    const i = e && Pe(t, o) || o;
    $(t[i]) && $(r) ? t[i] = se(t[i], r) : $(r) ? t[i] = se({}, r) : k(r) ? t[i] = r.slice() : t[i] = r;
  };
  for (let r = 0, o = arguments.length; r < o; r++)
    arguments[r] && I(arguments[r], n);
  return t;
}
const Et = (e, t, n, { allOwnKeys: r } = {}) => (I(t, (o, i) => {
  n && T(o) ? e[i] = Ne(o, n) : e[i] = o;
}, { allOwnKeys: r }), e), Rt = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Ot = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, St = (e, t, n, r) => {
  let o, i, s;
  const u = {};
  if (t = t || {}, e == null) return t;
  do {
    for (o = Object.getOwnPropertyNames(e), i = o.length; i-- > 0; )
      s = o[i], (!r || r(s, e, t)) && !u[s] && (t[s] = e[s], u[s] = !0);
    e = n !== !1 && fe(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, Tt = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, At = (e) => {
  if (!e) return null;
  if (k(e)) return e;
  let t = e.length;
  if (!Ue(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, xt = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && fe(Uint8Array)), Ct = (e, t) => {
  const n = (e && e[Symbol.iterator]).call(e);
  let r;
  for (; (r = n.next()) && !r.done; ) {
    const o = r.value;
    t.call(e, o[0], o[1]);
  }
}, vt = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, Nt = C("HTMLFormElement"), jt = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, n, r) {
    return n.toUpperCase() + r;
  }
), ge = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Ut = C("RegExp"), Fe = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  I(n, (o, i) => {
    let s;
    (s = t(o, i, e)) !== !1 && (r[i] = s || o);
  }), Object.defineProperties(e, r);
}, Pt = (e) => {
  Fe(e, (t, n) => {
    if (T(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (T(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, _t = (e, t) => {
  const n = {}, r = (o) => {
    o.forEach((i) => {
      n[i] = !0;
    });
  };
  return k(e) ? r(e) : r(String(e).split(t)), n;
}, Ft = () => {
}, kt = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function Dt(e) {
  return !!(e && T(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const Lt = (e) => {
  const t = new Array(10), n = (r, o) => {
    if (Z(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[o] = r;
        const i = k(r) ? [] : {};
        return I(r, (s, u) => {
          const f = n(s, o + 1);
          !q(f) && (i[u] = f);
        }), t[o] = void 0, i;
      }
    }
    return r;
  };
  return n(e, 0);
}, Bt = C("AsyncFunction"), qt = (e) => e && (Z(e) || T(e)) && T(e.then) && T(e.catch), ke = ((e, t) => e ? setImmediate : t ? ((n, r) => (U.addEventListener("message", ({ source: o, data: i }) => {
  o === U && i === n && r.length && r.shift()();
}, !1), (o) => {
  r.push(o), U.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  T(U.postMessage)
), It = typeof queueMicrotask < "u" ? queueMicrotask.bind(U) : typeof process < "u" && process.nextTick || ke, a = {
  isArray: k,
  isArrayBuffer: je,
  isBuffer: ot,
  isFormData: ht,
  isArrayBufferView: st,
  isString: it,
  isNumber: Ue,
  isBoolean: at,
  isObject: Z,
  isPlainObject: $,
  isReadableStream: mt,
  isRequest: gt,
  isResponse: yt,
  isHeaders: bt,
  isUndefined: q,
  isDate: ct,
  isFile: ut,
  isBlob: lt,
  isRegExp: Ut,
  isFunction: T,
  isStream: dt,
  isURLSearchParams: pt,
  isTypedArray: xt,
  isFileList: ft,
  forEach: I,
  merge: se,
  extend: Et,
  trim: wt,
  stripBOM: Rt,
  inherits: Ot,
  toFlatObject: St,
  kindOf: G,
  kindOfTest: C,
  endsWith: Tt,
  toArray: At,
  forEachEntry: Ct,
  matchAll: vt,
  isHTMLForm: Nt,
  hasOwnProperty: ge,
  hasOwnProp: ge,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Fe,
  freezeMethods: Pt,
  toObjectSet: _t,
  toCamelCase: jt,
  noop: Ft,
  toFiniteNumber: kt,
  findKey: Pe,
  global: U,
  isContextDefined: _e,
  isSpecCompliantForm: Dt,
  toJSONObject: Lt,
  isAsyncFn: Bt,
  isThenable: qt,
  setImmediate: ke,
  asap: It
};
function p(e, t, n, r, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), o && (this.response = o, this.status = o.status ? o.status : null);
}
a.inherits(p, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: a.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const De = p.prototype, Le = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Le[e] = { value: e };
});
Object.defineProperties(p, Le);
Object.defineProperty(De, "isAxiosError", { value: !0 });
p.from = (e, t, n, r, o, i) => {
  const s = Object.create(De);
  return a.toFlatObject(e, s, function(u) {
    return u !== Error.prototype;
  }, (u) => u !== "isAxiosError"), p.call(s, e.message, t, n, r, o), s.cause = e, s.name = e.name, i && Object.assign(s, i), s;
};
const zt = null;
function ie(e) {
  return a.isPlainObject(e) || a.isArray(e);
}
function Be(e) {
  return a.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function ye(e, t, n) {
  return e ? e.concat(t).map(function(r, o) {
    return r = Be(r), !n && o ? "[" + r + "]" : r;
  }).join(n ? "." : "") : t;
}
function Mt(e) {
  return a.isArray(e) && !e.some(ie);
}
const $t = a.toFlatObject(a, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function Q(e, t, n) {
  if (!a.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = a.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(d, g) {
    return !a.isUndefined(g[d]);
  });
  const r = n.metaTokens, o = n.visitor || c, i = n.dots, s = n.indexes, u = (n.Blob || typeof Blob < "u" && Blob) && a.isSpecCompliantForm(t);
  if (!a.isFunction(o))
    throw new TypeError("visitor must be a function");
  function f(d) {
    if (d === null) return "";
    if (a.isDate(d))
      return d.toISOString();
    if (!u && a.isBlob(d))
      throw new p("Blob is not supported. Use a Buffer instead.");
    return a.isArrayBuffer(d) || a.isTypedArray(d) ? u && typeof Blob == "function" ? new Blob([d]) : Buffer.from(d) : d;
  }
  function c(d, g, h) {
    let O = d;
    if (d && !h && typeof d == "object") {
      if (a.endsWith(g, "{}"))
        g = r ? g : g.slice(0, -2), d = JSON.stringify(d);
      else if (a.isArray(d) && Mt(d) || (a.isFileList(d) || a.endsWith(g, "[]")) && (O = a.toArray(d)))
        return g = Be(g), O.forEach(function(E, b) {
          !(a.isUndefined(E) || E === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? ye([g], b, i) : s === null ? g : g + "[]",
            f(E)
          );
        }), !1;
    }
    return ie(d) ? !0 : (t.append(ye(h, g, i), f(d)), !1);
  }
  const l = [], m = Object.assign($t, {
    defaultVisitor: c,
    convertValue: f,
    isVisitable: ie
  });
  function y(d, g) {
    if (!a.isUndefined(d)) {
      if (l.indexOf(d) !== -1)
        throw Error("Circular reference detected in " + g.join("."));
      l.push(d), a.forEach(d, function(h, O) {
        (!(a.isUndefined(h) || h === null) && o.call(
          t,
          h,
          a.isString(O) ? O.trim() : O,
          g,
          m
        )) === !0 && y(h, g ? g.concat(O) : [O]);
      }), l.pop();
    }
  }
  if (!a.isObject(e))
    throw new TypeError("data must be an object");
  return y(e), t;
}
function be(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function de(e, t) {
  this._pairs = [], e && Q(e, this, t);
}
const qe = de.prototype;
qe.append = function(e, t) {
  this._pairs.push([e, t]);
};
qe.toString = function(e) {
  const t = e ? function(n) {
    return e.call(this, n, be);
  } : be;
  return this._pairs.map(function(n) {
    return t(n[0]) + "=" + t(n[1]);
  }, "").join("&");
};
function Ht(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Ie(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || Ht;
  a.isFunction(n) && (n = {
    serialize: n
  });
  const o = n && n.serialize;
  let i;
  if (o ? i = o(t, n) : i = a.isURLSearchParams(t) ? t.toString() : new de(t, n).toString(r), i) {
    const s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class we {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    a.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const ze = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Jt = typeof URLSearchParams < "u" ? URLSearchParams : de, Wt = typeof FormData < "u" ? FormData : null, Vt = typeof Blob < "u" ? Blob : null, Kt = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Jt,
    FormData: Wt,
    Blob: Vt
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, he = typeof window < "u" && typeof document < "u", ae = typeof navigator == "object" && navigator || void 0, Gt = he && (!ae || ["ReactNative", "NativeScript", "NS"].indexOf(ae.product) < 0), Xt = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Zt = he && window.location.href || "http://localhost", Qt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: he,
  hasStandardBrowserEnv: Gt,
  hasStandardBrowserWebWorkerEnv: Xt,
  navigator: ae,
  origin: Zt
}, Symbol.toStringTag, { value: "Module" })), R = {
  ...Qt,
  ...Kt
};
function Yt(e, t) {
  return Q(e, new R.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, o, i) {
      return R.isNode && a.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function en(e) {
  return a.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function tn(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const o = n.length;
  let i;
  for (r = 0; r < o; r++)
    i = n[r], t[i] = e[i];
  return t;
}
function Me(e) {
  function t(n, r, o, i) {
    let s = n[i++];
    if (s === "__proto__") return !0;
    const u = Number.isFinite(+s), f = i >= n.length;
    return s = !s && a.isArray(o) ? o.length : s, f ? (a.hasOwnProp(o, s) ? o[s] = [o[s], r] : o[s] = r, !u) : ((!o[s] || !a.isObject(o[s])) && (o[s] = []), t(n, r, o[s], i) && a.isArray(o[s]) && (o[s] = tn(o[s])), !u);
  }
  if (a.isFormData(e) && a.isFunction(e.entries)) {
    const n = {};
    return a.forEachEntry(e, (r, o) => {
      t(en(r), o, n, 0);
    }), n;
  }
  return null;
}
function nn(e, t, n) {
  if (a.isString(e))
    try {
      return (t || JSON.parse)(e), a.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const z = {
  transitional: ze,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, t) {
    const n = t.getContentType() || "", r = n.indexOf("application/json") > -1, o = a.isObject(e);
    if (o && a.isHTMLForm(e) && (e = new FormData(e)), a.isFormData(e))
      return r ? JSON.stringify(Me(e)) : e;
    if (a.isArrayBuffer(e) || a.isBuffer(e) || a.isStream(e) || a.isFile(e) || a.isBlob(e) || a.isReadableStream(e))
      return e;
    if (a.isArrayBufferView(e))
      return e.buffer;
    if (a.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let i;
    if (o) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return Yt(e, this.formSerializer).toString();
      if ((i = a.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
        const s = this.env && this.env.FormData;
        return Q(
          i ? { "files[]": e } : e,
          s && new s(),
          this.formSerializer
        );
      }
    }
    return o || r ? (t.setContentType("application/json", !1), nn(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || z.transitional, n = t && t.forcedJSONParsing, r = this.responseType === "json";
    if (a.isResponse(e) || a.isReadableStream(e))
      return e;
    if (e && a.isString(e) && (n && !this.responseType || r)) {
      const o = !(t && t.silentJSONParsing) && r;
      try {
        return JSON.parse(e);
      } catch (i) {
        if (o)
          throw i.name === "SyntaxError" ? p.from(i, p.ERR_BAD_RESPONSE, this, null, this.response) : i;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: R.classes.FormData,
    Blob: R.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
a.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  z.headers[e] = {};
});
const rn = a.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), on = (e) => {
  const t = {};
  let n, r, o;
  return e && e.split(`
`).forEach(function(i) {
    o = i.indexOf(":"), n = i.substring(0, o).trim().toLowerCase(), r = i.substring(o + 1).trim(), !(!n || t[n] && rn[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, Ee = Symbol("internals");
function B(e) {
  return e && String(e).trim().toLowerCase();
}
function H(e) {
  return e === !1 || e == null ? e : a.isArray(e) ? e.map(H) : String(e);
}
function sn(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const an = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function ne(e, t, n, r, o) {
  if (a.isFunction(r))
    return r.call(this, t, n);
  if (o && (t = n), !!a.isString(t)) {
    if (a.isString(r))
      return t.indexOf(r) !== -1;
    if (a.isRegExp(r))
      return r.test(t);
  }
}
function cn(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function un(e, t) {
  const n = a.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(o, i, s) {
        return this[r].call(this, t, o, i, s);
      },
      configurable: !0
    });
  });
}
let S = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, t, n) {
    const r = this;
    function o(s, u, f) {
      const c = B(u);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const l = a.findKey(r, c);
      (!l || r[l] === void 0 || f === !0 || f === void 0 && r[l] !== !1) && (r[l || u] = H(s));
    }
    const i = (s, u) => a.forEach(s, (f, c) => o(f, c, u));
    if (a.isPlainObject(e) || e instanceof this.constructor)
      i(e, t);
    else if (a.isString(e) && (e = e.trim()) && !an(e))
      i(on(e), t);
    else if (a.isHeaders(e))
      for (const [s, u] of e.entries())
        o(u, s, n);
    else
      e != null && o(t, e, n);
    return this;
  }
  get(e, t) {
    if (e = B(e), e) {
      const n = a.findKey(this, e);
      if (n) {
        const r = this[n];
        if (!t)
          return r;
        if (t === !0)
          return sn(r);
        if (a.isFunction(t))
          return t.call(this, r, n);
        if (a.isRegExp(t))
          return t.exec(r);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, t) {
    if (e = B(e), e) {
      const n = a.findKey(this, e);
      return !!(n && this[n] !== void 0 && (!t || ne(this, this[n], n, t)));
    }
    return !1;
  }
  delete(e, t) {
    const n = this;
    let r = !1;
    function o(i) {
      if (i = B(i), i) {
        const s = a.findKey(n, i);
        s && (!t || ne(n, n[s], s, t)) && (delete n[s], r = !0);
      }
    }
    return a.isArray(e) ? e.forEach(o) : o(e), r;
  }
  clear(e) {
    const t = Object.keys(this);
    let n = t.length, r = !1;
    for (; n--; ) {
      const o = t[n];
      (!e || ne(this, this[o], o, e, !0)) && (delete this[o], r = !0);
    }
    return r;
  }
  normalize(e) {
    const t = this, n = {};
    return a.forEach(this, (r, o) => {
      const i = a.findKey(n, o);
      if (i) {
        t[i] = H(r), delete t[o];
        return;
      }
      const s = e ? cn(o) : String(o).trim();
      s !== o && delete t[o], t[s] = H(r), n[s] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const t = /* @__PURE__ */ Object.create(null);
    return a.forEach(this, (n, r) => {
      n != null && n !== !1 && (t[r] = e && a.isArray(n) ? n.join(", ") : n);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...t) {
    const n = new this(e);
    return t.forEach((r) => n.set(r)), n;
  }
  static accessor(e) {
    const t = (this[Ee] = this[Ee] = {
      accessors: {}
    }).accessors, n = this.prototype;
    function r(o) {
      const i = B(o);
      t[i] || (un(n, o), t[i] = !0);
    }
    return a.isArray(e) ? e.forEach(r) : r(e), this;
  }
};
S.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
a.reduceDescriptors(S.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
a.freezeMethods(S);
function re(e, t) {
  const n = this || z, r = t || n, o = S.from(r.headers);
  let i = r.data;
  return a.forEach(e, function(s) {
    i = s.call(n, i, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), i;
}
function $e(e) {
  return !!(e && e.__CANCEL__);
}
function D(e, t, n) {
  p.call(this, e ?? "canceled", p.ERR_CANCELED, t, n), this.name = "CanceledError";
}
a.inherits(D, p, {
  __CANCEL__: !0
});
function He(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new p(
    "Request failed with status code " + n.status,
    [p.ERR_BAD_REQUEST, p.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function ln(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function fn(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let o = 0, i = 0, s;
  return t = t !== void 0 ? t : 1e3, function(u) {
    const f = Date.now(), c = r[i];
    s || (s = f), n[o] = u, r[o] = f;
    let l = i, m = 0;
    for (; l !== o; )
      m += n[l++], l = l % e;
    if (o = (o + 1) % e, o === i && (i = (i + 1) % e), f - s < t)
      return;
    const y = c && f - c;
    return y ? Math.round(m * 1e3 / y) : void 0;
  };
}
function dn(e, t) {
  let n = 0, r = 1e3 / t, o, i;
  const s = (u, f = Date.now()) => {
    n = f, o = null, i && (clearTimeout(i), i = null), e.apply(null, u);
  };
  return [(...u) => {
    const f = Date.now(), c = f - n;
    c >= r ? s(u, f) : (o = u, i || (i = setTimeout(() => {
      i = null, s(o);
    }, r - c)));
  }, () => o && s(o)];
}
const V = (e, t, n = 3) => {
  let r = 0;
  const o = fn(50, 250);
  return dn((i) => {
    const s = i.loaded, u = i.lengthComputable ? i.total : void 0, f = s - r, c = o(f), l = s <= u;
    r = s;
    const m = {
      loaded: s,
      total: u,
      progress: u ? s / u : void 0,
      bytes: f,
      rate: c || void 0,
      estimated: c && u && l ? (u - s) / c : void 0,
      event: i,
      lengthComputable: u != null,
      [t ? "download" : "upload"]: !0
    };
    e(m);
  }, n);
}, Re = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: r
  }), t[1]];
}, Oe = (e) => (...t) => a.asap(() => e(...t)), hn = R.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, R.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(R.origin),
  R.navigator && /(msie|trident)/i.test(R.navigator.userAgent)
) : () => !0, pn = R.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, o, i) {
      const s = [e + "=" + encodeURIComponent(t)];
      a.isNumber(n) && s.push("expires=" + new Date(n).toGMTString()), a.isString(r) && s.push("path=" + r), a.isString(o) && s.push("domain=" + o), i === !0 && s.push("secure"), document.cookie = s.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function mn(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function gn(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Je(e, t, n) {
  let r = !mn(t);
  return e && r || n == !1 ? gn(e, t) : t;
}
const Se = (e) => e instanceof S ? { ...e } : e;
function _(e, t) {
  t = t || {};
  const n = {};
  function r(c, l, m, y) {
    return a.isPlainObject(c) && a.isPlainObject(l) ? a.merge.call({ caseless: y }, c, l) : a.isPlainObject(l) ? a.merge({}, l) : a.isArray(l) ? l.slice() : l;
  }
  function o(c, l, m, y) {
    if (a.isUndefined(l)) {
      if (!a.isUndefined(c))
        return r(void 0, c, m, y);
    } else return r(c, l, m, y);
  }
  function i(c, l) {
    if (!a.isUndefined(l))
      return r(void 0, l);
  }
  function s(c, l) {
    if (a.isUndefined(l)) {
      if (!a.isUndefined(c))
        return r(void 0, c);
    } else return r(void 0, l);
  }
  function u(c, l, m) {
    if (m in t)
      return r(c, l);
    if (m in e)
      return r(void 0, c);
  }
  const f = {
    url: i,
    method: i,
    data: i,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: u,
    headers: (c, l, m) => o(Se(c), Se(l), m, !0)
  };
  return a.forEach(Object.keys(Object.assign({}, e, t)), function(c) {
    const l = f[c] || o, m = l(e[c], t[c], c);
    a.isUndefined(m) && l !== u || (n[c] = m);
  }), n;
}
const We = (e) => {
  const t = _({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: o, xsrfCookieName: i, headers: s, auth: u } = t;
  t.headers = s = S.from(s), t.url = Ie(Je(t.baseURL, t.url), e.params, e.paramsSerializer), u && s.set(
    "Authorization",
    "Basic " + btoa((u.username || "") + ":" + (u.password ? unescape(encodeURIComponent(u.password)) : ""))
  );
  let f;
  if (a.isFormData(n)) {
    if (R.hasStandardBrowserEnv || R.hasStandardBrowserWebWorkerEnv)
      s.setContentType(void 0);
    else if ((f = s.getContentType()) !== !1) {
      const [c, ...l] = f ? f.split(";").map((m) => m.trim()).filter(Boolean) : [];
      s.setContentType([c || "multipart/form-data", ...l].join("; "));
    }
  }
  if (R.hasStandardBrowserEnv && (r && a.isFunction(r) && (r = r(t)), r || r !== !1 && hn(t.url))) {
    const c = o && i && pn.read(i);
    c && s.set(o, c);
  }
  return t;
}, yn = typeof XMLHttpRequest < "u", bn = yn && function(e) {
  return new Promise(function(t, n) {
    const r = We(e);
    let o = r.data;
    const i = S.from(r.headers).normalize();
    let { responseType: s, onUploadProgress: u, onDownloadProgress: f } = r, c, l, m, y, d;
    function g() {
      y && y(), d && d(), r.cancelToken && r.cancelToken.unsubscribe(c), r.signal && r.signal.removeEventListener("abort", c);
    }
    let h = new XMLHttpRequest();
    h.open(r.method.toUpperCase(), r.url, !0), h.timeout = r.timeout;
    function O() {
      if (!h)
        return;
      const b = S.from(
        "getAllResponseHeaders" in h && h.getAllResponseHeaders()
      ), N = {
        data: !s || s === "text" || s === "json" ? h.responseText : h.response,
        status: h.status,
        statusText: h.statusText,
        headers: b,
        config: e,
        request: h
      };
      He(function(L) {
        t(L), g();
      }, function(L) {
        n(L), g();
      }, N), h = null;
    }
    "onloadend" in h ? h.onloadend = O : h.onreadystatechange = function() {
      !h || h.readyState !== 4 || h.status === 0 && !(h.responseURL && h.responseURL.indexOf("file:") === 0) || setTimeout(O);
    }, h.onabort = function() {
      h && (n(new p("Request aborted", p.ECONNABORTED, e, h)), h = null);
    }, h.onerror = function() {
      n(new p("Network Error", p.ERR_NETWORK, e, h)), h = null;
    }, h.ontimeout = function() {
      let b = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const N = r.transitional || ze;
      r.timeoutErrorMessage && (b = r.timeoutErrorMessage), n(new p(
        b,
        N.clarifyTimeoutError ? p.ETIMEDOUT : p.ECONNABORTED,
        e,
        h
      )), h = null;
    }, o === void 0 && i.setContentType(null), "setRequestHeader" in h && a.forEach(i.toJSON(), function(b, N) {
      h.setRequestHeader(N, b);
    }), a.isUndefined(r.withCredentials) || (h.withCredentials = !!r.withCredentials), s && s !== "json" && (h.responseType = r.responseType), f && ([m, d] = V(f, !0), h.addEventListener("progress", m)), u && h.upload && ([l, y] = V(u), h.upload.addEventListener("progress", l), h.upload.addEventListener("loadend", y)), (r.cancelToken || r.signal) && (c = (b) => {
      h && (n(!b || b.type ? new D(null, e, h) : b), h.abort(), h = null);
    }, r.cancelToken && r.cancelToken.subscribe(c), r.signal && (r.signal.aborted ? c() : r.signal.addEventListener("abort", c)));
    const E = ln(r.url);
    if (E && R.protocols.indexOf(E) === -1) {
      n(new p("Unsupported protocol " + E + ":", p.ERR_BAD_REQUEST, e));
      return;
    }
    h.send(o || null);
  });
}, wn = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let r = new AbortController(), o;
    const i = function(c) {
      if (!o) {
        o = !0, u();
        const l = c instanceof Error ? c : this.reason;
        r.abort(l instanceof p ? l : new D(l instanceof Error ? l.message : l));
      }
    };
    let s = t && setTimeout(() => {
      s = null, i(new p(`timeout ${t} of ms exceeded`, p.ETIMEDOUT));
    }, t);
    const u = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(i) : c.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", i));
    const { signal: f } = r;
    return f.unsubscribe = () => a.asap(u), f;
  }
}, En = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let r = 0, o;
  for (; r < n; )
    o = r + t, yield e.slice(r, o), r = o;
}, Rn = async function* (e, t) {
  for await (const n of On(e))
    yield* En(n, t);
}, On = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: r } = await t.read();
      if (n)
        break;
      yield r;
    }
  } finally {
    await t.cancel();
  }
}, Te = (e, t, n, r) => {
  const o = Rn(e, t);
  let i = 0, s, u = (f) => {
    s || (s = !0, r && r(f));
  };
  return new ReadableStream({
    async pull(f) {
      try {
        const { done: c, value: l } = await o.next();
        if (c) {
          u(), f.close();
          return;
        }
        let m = l.byteLength;
        if (n) {
          let y = i += m;
          n(y);
        }
        f.enqueue(new Uint8Array(l));
      } catch (c) {
        throw u(c), c;
      }
    },
    cancel(f) {
      return u(f), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, Y = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Ve = Y && typeof ReadableStream == "function", Sn = Y && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), Ke = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, Tn = Ve && Ke(() => {
  let e = !1;
  const t = new Request(R.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), Ae = 64 * 1024, ce = Ve && Ke(() => a.isReadableStream(new Response("").body)), K = {
  stream: ce && ((e) => e.body)
};
Y && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !K[t] && (K[t] = a.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new p(`Response type '${t}' is not supported`, p.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const An = async (e) => {
  if (e == null)
    return 0;
  if (a.isBlob(e))
    return e.size;
  if (a.isSpecCompliantForm(e))
    return (await new Request(R.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (a.isArrayBufferView(e) || a.isArrayBuffer(e))
    return e.byteLength;
  if (a.isURLSearchParams(e) && (e = e + ""), a.isString(e))
    return (await Sn(e)).byteLength;
}, xn = async (e, t) => a.toFiniteNumber(e.getContentLength()) ?? An(t), Cn = Y && (async (e) => {
  let {
    url: t,
    method: n,
    data: r,
    signal: o,
    cancelToken: i,
    timeout: s,
    onDownloadProgress: u,
    onUploadProgress: f,
    responseType: c,
    headers: l,
    withCredentials: m = "same-origin",
    fetchOptions: y
  } = We(e);
  c = c ? (c + "").toLowerCase() : "text";
  let d = wn([o, i && i.toAbortSignal()], s), g;
  const h = d && d.unsubscribe && (() => {
    d.unsubscribe();
  });
  let O;
  try {
    if (f && Tn && n !== "get" && n !== "head" && (O = await xn(l, r)) !== 0) {
      let j = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), F;
      if (a.isFormData(r) && (F = j.headers.get("content-type")) && l.setContentType(F), j.body) {
        const [te, M] = Re(
          O,
          V(Oe(f))
        );
        r = Te(j.body, Ae, te, M);
      }
    }
    a.isString(m) || (m = m ? "include" : "omit");
    const E = "credentials" in Request.prototype;
    g = new Request(t, {
      ...y,
      signal: d,
      method: n.toUpperCase(),
      headers: l.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: E ? m : void 0
    });
    let b = await fetch(g);
    const N = ce && (c === "stream" || c === "response");
    if (ce && (u || N && h)) {
      const j = {};
      ["status", "statusText", "headers"].forEach((pe) => {
        j[pe] = b[pe];
      });
      const F = a.toFiniteNumber(b.headers.get("content-length")), [te, M] = u && Re(
        F,
        V(Oe(u), !0)
      ) || [];
      b = new Response(
        Te(b.body, Ae, te, () => {
          M && M(), h && h();
        }),
        j
      );
    }
    c = c || "text";
    let L = await K[a.findKey(K, c) || "text"](b, e);
    return !N && h && h(), await new Promise((j, F) => {
      He(j, F, {
        data: L,
        headers: S.from(b.headers),
        status: b.status,
        statusText: b.statusText,
        config: e,
        request: g
      });
    });
  } catch (E) {
    throw h && h(), E && E.name === "TypeError" && /fetch/i.test(E.message) ? Object.assign(
      new p("Network Error", p.ERR_NETWORK, e, g),
      {
        cause: E.cause || E
      }
    ) : p.from(E, E && E.code, e, g);
  }
}), ue = {
  http: zt,
  xhr: bn,
  fetch: Cn
};
a.forEach(ue, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const xe = (e) => `- ${e}`, vn = (e) => a.isFunction(e) || e === null || e === !1, Ge = {
  getAdapter: (e) => {
    e = a.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const o = {};
    for (let i = 0; i < t; i++) {
      n = e[i];
      let s;
      if (r = n, !vn(n) && (r = ue[(s = String(n)).toLowerCase()], r === void 0))
        throw new p(`Unknown adapter '${s}'`);
      if (r)
        break;
      o[s || "#" + i] = r;
    }
    if (!r) {
      const i = Object.entries(o).map(
        ([u, f]) => `adapter ${u} ` + (f === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let s = t ? i.length > 1 ? `since :
` + i.map(xe).join(`
`) : " " + xe(i[0]) : "as no adapter specified";
      throw new p(
        "There is no suitable adapter to dispatch the request " + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: ue
};
function oe(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new D(null, e);
}
function Ce(e) {
  return oe(e), e.headers = S.from(e.headers), e.data = re.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Ge.getAdapter(e.adapter || z.adapter)(e).then(function(t) {
    return oe(e), t.data = re.call(
      e,
      e.transformResponse,
      t
    ), t.headers = S.from(t.headers), t;
  }, function(t) {
    return $e(t) || (oe(e), t && t.response && (t.response.data = re.call(
      e,
      e.transformResponse,
      t.response
    ), t.response.headers = S.from(t.response.headers))), Promise.reject(t);
  });
}
const Xe = "1.8.2", ee = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  ee[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const ve = {};
ee.transitional = function(e, t, n) {
  function r(o, i) {
    return "[Axios v" + Xe + "] Transitional option '" + o + "'" + i + (n ? ". " + n : "");
  }
  return (o, i, s) => {
    if (e === !1)
      throw new p(
        r(i, " has been removed" + (t ? " in " + t : "")),
        p.ERR_DEPRECATED
      );
    return t && !ve[i] && (ve[i] = !0, console.warn(
      r(
        i,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(o, i, s) : !0;
  };
};
ee.spelling = function(e) {
  return (t, n) => (console.warn(`${n} is likely a misspelling of ${e}`), !0);
};
function Nn(e, t, n) {
  if (typeof e != "object")
    throw new p("options must be an object", p.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let o = r.length;
  for (; o-- > 0; ) {
    const i = r[o], s = t[i];
    if (s) {
      const u = e[i], f = u === void 0 || s(u, i, e);
      if (f !== !0)
        throw new p("option " + i + " must be " + f, p.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new p("Unknown option " + i, p.ERR_BAD_OPTION);
  }
}
const J = {
  assertOptions: Nn,
  validators: ee
}, v = J.validators;
let P = class {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new we(),
      response: new we()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, t) {
    try {
      return await this._request(e, t);
    } catch (n) {
      if (n instanceof Error) {
        let r = {};
        Error.captureStackTrace ? Error.captureStackTrace(r) : r = new Error();
        const o = r.stack ? r.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? o && !String(n.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + o) : n.stack = o;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = _(this.defaults, t);
    const { transitional: n, paramsSerializer: r, headers: o } = t;
    n !== void 0 && J.assertOptions(n, {
      silentJSONParsing: v.transitional(v.boolean),
      forcedJSONParsing: v.transitional(v.boolean),
      clarifyTimeoutError: v.transitional(v.boolean)
    }, !1), r != null && (a.isFunction(r) ? t.paramsSerializer = {
      serialize: r
    } : J.assertOptions(r, {
      encode: v.function,
      serialize: v.function
    }, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : t.allowAbsoluteUrls = !0), J.assertOptions(t, {
      baseUrl: v.spelling("baseURL"),
      withXsrfToken: v.spelling("withXSRFToken")
    }, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let i = o && a.merge(
      o.common,
      o[t.method]
    );
    o && a.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (d) => {
        delete o[d];
      }
    ), t.headers = S.concat(i, o);
    const s = [];
    let u = !0;
    this.interceptors.request.forEach(function(d) {
      typeof d.runWhen == "function" && d.runWhen(t) === !1 || (u = u && d.synchronous, s.unshift(d.fulfilled, d.rejected));
    });
    const f = [];
    this.interceptors.response.forEach(function(d) {
      f.push(d.fulfilled, d.rejected);
    });
    let c, l = 0, m;
    if (!u) {
      const d = [Ce.bind(this), void 0];
      for (d.unshift.apply(d, s), d.push.apply(d, f), m = d.length, c = Promise.resolve(t); l < m; )
        c = c.then(d[l++], d[l++]);
      return c;
    }
    m = s.length;
    let y = t;
    for (l = 0; l < m; ) {
      const d = s[l++], g = s[l++];
      try {
        y = d(y);
      } catch (h) {
        g.call(this, h);
        break;
      }
    }
    try {
      c = Ce.call(this, y);
    } catch (d) {
      return Promise.reject(d);
    }
    for (l = 0, m = f.length; l < m; )
      c = c.then(f[l++], f[l++]);
    return c;
  }
  getUri(e) {
    e = _(this.defaults, e);
    const t = Je(e.baseURL, e.url, e.allowAbsoluteUrls);
    return Ie(t, e.params, e.paramsSerializer);
  }
};
a.forEach(["delete", "get", "head", "options"], function(e) {
  P.prototype[e] = function(t, n) {
    return this.request(_(n || {}, {
      method: e,
      url: t,
      data: (n || {}).data
    }));
  };
});
a.forEach(["post", "put", "patch"], function(e) {
  function t(n) {
    return function(r, o, i) {
      return this.request(_(i || {}, {
        method: e,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: r,
        data: o
      }));
    };
  }
  P.prototype[e] = t(), P.prototype[e + "Form"] = t(!0);
});
let jn = class Ze {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(o) {
      n = o;
    });
    const r = this;
    this.promise.then((o) => {
      if (!r._listeners) return;
      let i = r._listeners.length;
      for (; i-- > 0; )
        r._listeners[i](o);
      r._listeners = null;
    }), this.promise.then = (o) => {
      let i;
      const s = new Promise((u) => {
        r.subscribe(u), i = u;
      }).then(o);
      return s.cancel = function() {
        r.unsubscribe(i);
      }, s;
    }, t(function(o, i, s) {
      r.reason || (r.reason = new D(o, i, s), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (r) => {
      t.abort(r);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Ze(function(n) {
        t = n;
      }),
      cancel: t
    };
  }
};
function Un(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function Pn(e) {
  return a.isObject(e) && e.isAxiosError === !0;
}
const le = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(le).forEach(([e, t]) => {
  le[t] = e;
});
function Qe(e) {
  const t = new P(e), n = Ne(P.prototype.request, t);
  return a.extend(n, P.prototype, t, { allOwnKeys: !0 }), a.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(r) {
    return Qe(_(e, r));
  }, n;
}
const w = Qe(z);
w.Axios = P;
w.CanceledError = D;
w.CancelToken = jn;
w.isCancel = $e;
w.VERSION = Xe;
w.toFormData = Q;
w.AxiosError = p;
w.Cancel = w.CanceledError;
w.all = function(e) {
  return Promise.all(e);
};
w.spread = Un;
w.isAxiosError = Pn;
w.mergeConfig = _;
w.AxiosHeaders = S;
w.formToJSON = (e) => Me(a.isHTMLForm(e) ? new FormData(e) : e);
w.getAdapter = Ge.getAdapter;
w.HttpStatusCode = le;
w.default = w;
const {
  Axios: $n,
  AxiosError: _n,
  CanceledError: Hn,
  isCancel: Jn,
  CancelToken: Wn,
  VERSION: Vn,
  all: Kn,
  Cancel: Gn,
  isAxiosError: Xn,
  spread: Zn,
  toFormData: Qn,
  AxiosHeaders: Yn,
  HttpStatusCode: er,
  formToJSON: tr,
  getAdapter: nr,
  mergeConfig: rr
} = w, Fn = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_,+.~#?&/=]*)$/;
class kn {
  constructor(t, n = {}) {
    W(this, "baseUrl"), W(this, "headers"), this.baseUrl = t, this.headers = (n == null ? void 0 : n.headers) || {};
  }
  async fetch(t, n = "GET", r = {}) {
    var o;
    if (!this.baseUrl)
      throw new Error("No base URL set");
    const i = Fn.test(t) ? t : `${this.baseUrl}${t}`;
    i.includes(this.baseUrl) && (r.withCredentials = !0);
    try {
      return (await w(i, {
        ...r,
        method: n,
        data: r.data,
        headers: { ...this.headers, ...r.headers },
        withCredentials: r.withCredentials
      })).data;
    } catch (s) {
      throw s instanceof _n ? new me(`${s.code} - ${s.status} - ${i}`, s.status, (o = s.response) == null ? void 0 : o.data) : new me("An error occured while fetching");
    }
  }
  getBaseUrl() {
    return this.baseUrl;
  }
  setBaseUrl(t) {
    this.baseUrl = t;
  }
  async get(t, n = {}) {
    return this.fetch(t, "GET", n);
  }
  async post(t, n = {}) {
    return this.fetch(t, "POST", {
      ...n,
      headers: {
        "Content-Type": "application/json",
        ...n.headers
      }
    });
  }
  async put(t, n = {}) {
    return this.fetch(t, "PUT", {
      ...n,
      headers: {
        "Content-Type": "application/json",
        ...n.headers
      }
    });
  }
  async delete(t, n = {}) {
    return this.fetch(t, "DELETE", n);
  }
  async patch(t, n = {}) {
    return this.fetch(t, "PATCH", {
      ...n,
      headers: {
        "Content-Type": "application/json",
        ...n.headers
      }
    });
  }
}
let A;
function or(e, t = {}) {
  A = new kn(e, t);
}
const Dn = 3, Ln = (e, t) => {
  const n = typeof t.guest.id == "string" ? parseInt(t.guest.id, 10) : t.guest.id, r = typeof t.host.id == "string" ? parseInt(t.host.id, 10) : t.host.id, o = e.id;
  return n === o || r === o;
}, Bn = (e, t) => e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth() && e.getDate() === t.getDate(), qn = (e) => {
  const t = /* @__PURE__ */ new Date(), n = new Date(e.start_on);
  return e.status === Dn && (Bn(t, n) || n > t);
}, sr = (e, t) => {
  const n = t.exchanges.every(qn);
  return t.exchanges.some((o) => Ln(e, o)) && n;
};
async function ir(e, t) {
  try {
    const n = et(t);
    return await A.get(`/exchange/${e}/cancel`, { headers: n });
  } catch {
    throw new Error("Error while getting the conversation informations");
  }
}
async function ar(e, t, n) {
  try {
    const r = x();
    return await A.patch(`/exchange/${e}/cancel`, {
      headers: r,
      data: { cancellationReasonId: +t, comment: n }
    });
  } catch {
    throw new Error("Error while cancelling the conversation");
  }
}
async function cr({ stayType: e, startDate: t, endDate: n, homeId: r, hostId: o, guestId: i, guestNumber: s, content: u }, f = {}) {
  const c = x(f);
  return A.post("/exchange", {
    headers: c,
    data: JSON.stringify({
      stayType: e,
      startDate: t,
      endDate: n,
      homeId: r,
      hostId: o,
      guestId: i,
      guestNumber: s,
      content: u
    })
  });
}
async function ur(e = {}) {
  const t = x(e);
  return A.get("/exchange/config", { headers: t });
}
async function lr(e, t = {}) {
  const n = x(t);
  return A.patch(`/exchange/${e}/pre-approve`, { headers: n });
}
async function fr(e, t = {}) {
  const n = x(t);
  return A.get(`/exchange/${e}`, { headers: n });
}
async function dr(e, t = {}) {
  const n = x(t);
  return A.get(`/exchange/v2/${e}`, { headers: n });
}
async function hr(e, t = {}) {
  const n = x(t);
  return await A.patch(`/exchange/${e}/pre-approve-cancel`, { headers: n });
}
async function pr(e, t, n = {}) {
  const r = x(n);
  return A.patch(`/exchange/${e}/update-dates`, {
    headers: {
      ...r,
      "Content-Type": "application/json"
    },
    data: JSON.stringify(t)
  });
}
async function mr(e, t, n = {}) {
  const r = x(n);
  return A.patch(`/exchange/${e}/change-to-reciprocal/${t}`, {
    headers: r
  });
}
async function gr(e, t, n = {}) {
  const r = x(n);
  return A.patch(`/exchange/${e}/change-to-non-reciprocal/${t}`, {
    headers: r
  });
}
async function yr(e, t, n = {}) {
  const r = x(n);
  return A.patch(`/exchange/${e}/manual-decline`, {
    headers: r,
    data: JSON.stringify({ isPresetModified: t })
  });
}
export {
  cr as a,
  ur as b,
  ar as c,
  fr as d,
  dr as e,
  hr as f,
  ir as g,
  mr as h,
  gr as i,
  A as j,
  sr as k,
  zn as l,
  yr as m,
  Mn as n,
  lr as p,
  or as s,
  pr as u
};
